module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/sprite-main/icon-sync-34a871e480bfebe3b0e5314f0b84eada.svg";